const pageBorders = [
  // {
  //   page: '3',
  //   desktop: './img/divider-desktop.png',
  //   mobile: './img/divider-top.png',
  // },
  // {
  //   page: '5',
  //   desktop: './img/divider-desktop-thick.jpg',
  //   mobile: './img/divider-mobile-thick.jpg',
  // },
  // {
  //   page: '7',
  //   desktop: './img/divider-desktop.png',
  //   mobile: './img/divider-mobile-medium.jpg',
  // },
];

export default pageBorders;